<app-section-header-gap
  *ngIf="mediaService.isLtXl$ | async"
></app-section-header-gap>
<div class="container">
  <app-banner-one
    (infoClick)="scrollToBooks()"
    class="container__banner"
  ></app-banner-one>
  <lib-section-features
    class="container__features"
    [featuresData]="featuresData"
  ></lib-section-features>
  <app-section-books
    id="preform"
    class="container__section container__books"
    [books]="books"
    [disableCarousel]="true"
  >
  </app-section-books>
  <div
    id="reviews"
    class="container__reviews"
  >
    <lib-section-reviews-yotpo-v3-common
      title="リアルタイムレビュー"
      instanceId="1282529"
      [showMonster]="true"
    ></lib-section-reviews-yotpo-v3-common>
  </div>
  <div class="container__steps">
    <lib-section-steps [steps]="sectionSteps"></lib-section-steps>
  </div>
  <div
    *ngIf="descriptionData"
    class="container__description"
  >
    <lib-description [description]="descriptionData"></lib-description>
  </div>
  <div class="container__faq">
    <lib-section-faq
      [condensed]="true"
      [faqData]="faqDataCondensed"
      (buttonClick)="onFaqButtonClick()"
    ></lib-section-faq>
  </div>
  <div class="container__about-banner">
    <app-section-about-banner></app-section-about-banner>
  </div>
</div>

<app-scroll-top></app-scroll-top>

<ng-template
  #reviewsTpl
  let-review
>
  <section class="reviews">
    <div class="reviews__content">
      <p
        *ngFor="let text of review.text"
        class="reviews-text"
      >
        {{ text }}
      </p>
    </div>
    <footer class="reviews__footer">
      <a
        href="#reviews"
        class="reviews-text"
        >レビューを読む</a
      >
      <img
        src="assets/images/reviews-stars.png"
        alt="★★★★★"
        class="reviews-stars"
      />
    </footer>
  </section>
</ng-template>
